var KEY = 'CAD_token';

var setToken = function setToken(token) {
  localStorage.setItem(KEY, token);
};

var getToken = function getToken() {
  return localStorage.getItem(KEY);
};

var removeToken = function removeToken() {
  localStorage.removeItem(KEY);
}; // 按需导出 导出对象


export { setToken, getToken, removeToken };